import { VersionLifecycleStatus } from 'app/developer-v3/types/statuses';

export function getVersionStatusLabel(lifecycleStatus: VersionLifecycleStatus) {
  if (lifecycleStatus === VersionLifecycleStatus.promoted) {
    return 'Promoted';
  }
  if (lifecycleStatus === VersionLifecycleStatus.private) {
    return 'Private';
  }
  if (lifecycleStatus === VersionLifecycleStatus.draft) {
    return 'Draft';
  }
  if (lifecycleStatus === VersionLifecycleStatus.available) {
    return 'Available';
  }
  if (lifecycleStatus === VersionLifecycleStatus.legacy) {
    return 'Legacy';
  }
  if (lifecycleStatus === VersionLifecycleStatus.deprecating) {
    return 'Deprecating';
  }
  if (lifecycleStatus === VersionLifecycleStatus.deprecated) {
    return 'Deprecated';
  }
  return 'Draft';
}

export function getTimeZoneShortLabel(date: Date): string {
  const genericParts = new Intl.DateTimeFormat(undefined, {
    timeZoneName: 'shortGeneric',
  }).formatToParts(date);
  const generic = genericParts.find(p => p.type === 'timeZoneName')?.value;
  if (generic) return generic;
  const shortParts = new Intl.DateTimeFormat(undefined, {
    timeZoneName: 'short',
  }).formatToParts(date);
  return shortParts.find(p => p.type === 'timeZoneName')?.value ?? '';
}
